import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import moment from "moment";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ViewIcon from "../../../components/Icons/ViewIcon";
import CommonTable from "../../../components/comman/CommonTable";

const PendingGRN = ({ siteId }) => {
  const navigate = useNavigate();
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    grnList: [],
  });

  useEffect(() => {
      GetGrnList();
  }, [siteId]);

  const GetGrnList = (pageNo) => {
    let options = {
      method: "GET",
    };

    const Url =
      apiUrl.get_GRN +
      `pageNumber=1&pageSize=5&status=created${siteId ? `&siteId=${siteId}`: ""}`;
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.grn?.map((item) => ({
          ...item,
          siteName: item?.site?.name,
          grnDate: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
        }));
        setPageStates((pre) => ({
          ...pre,
          grnList: newData,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "grnNumber", label: "GRN Number" },
    { value: "siteName", label: "Site Name" },
    { value: "grnDate", label: "Date" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentTicketStatus", label: "Status" },
  ];

  const HandleView = (data) => {
    navigate(RoutesLink.grn_detail + `/${data?.id}`);
  };

  const ActionDataForPending = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];
  return (
    <div className="col-12 col-lg-6">
      <div className="card height-full">
        <div className="card-body">
          <div className="card-head">
            <h3 className="card-title">Pending GRN</h3>

            <button
              type="button"
              className="btn btn-outline-primary py-1"
              onClick={() => navigate(RoutesLink?.grn)}
            >
              View All
            </button>
          </div>
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates?.grnList}
            ActionData={ActionDataForPending}
            isLoading={pageStates?.tableLoader}
          />
        </div>
      </div>
    </div>
  );
};

export default PendingGRN;
